module.exports = __webpack_public_path__ + "img/Picture25.1bfec43f.png";